import DocumentsCard from './DocumentsCard';

export default DocumentsCard;
